/**
 * Static content used across the landing page.
 * Extracted out of components so each render function stays lean and testable,
 * and so future copy edits happen in a single, well-lit place.
 */

export const CREDENTIALS = [
    { id: "experience", label: "11 anos de atuação clínica e cirúrgica" },
    {
        id: "academic",
        label: "Mestre e Doutor em Cirurgia Buco-Maxilo-Facial",
    },
    { id: "professor", label: "Professor Universitário" },
    {
        id: "iti",
        label:
            "Membro do International Team for Implantology (ITI \u2014 Suíça)",
    },
    {
        id: "protocol",
        label: "Criador do Protocolo \u201cCirurgia sem dor\u201d",
    },
];

export const TECH_CARDS = [
    {
        id: "scan-3d",
        title: "Escaneamento Intraoral 3D",
        body: "Moldagens digitais sem desconforto, garantindo precisão milimétrica nas próteses.",
        image: "/images/tech-01-scan.jpg",
        alt: "Scanner intraoral 3D exibindo modelo digital dos arcos dentários em tempo real",
    },
    {
        id: "virtual-planning",
        title: "Planejamento Virtual",
        body: "Previsibilidade total. A cirurgia é simulada em software antes de ser executada.",
        image:
            "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1400&q=80",
        alt: "Planejamento cirúrgico digital em software 3D",
    },
    {
        id: "minimally-invasive",
        title: "Cirurgias Minimamente Invasivas",
        body: "Mapeamos sua anatomia digitalmente para cirurgias rápidas e de precisão milimétrica, muitas vezes sem bisturi. Máximo conforto, zero trauma e zero dor.",
        image:
            "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=1400&q=80",
        alt: "Cirurgia guiada por planejamento digital \u2014 abordagem minimamente invasiva",
    },
];
